// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "dist/" + {"351":"exhibition-agenda","691":"estados-municipios","702":"itinerary-metabox","917":"reports-page","985":"status-metabox"}[chunkId] + ".js";
};